import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Configuration } from '../constants/configs';
import { ENVIRONMENT_CONFIG } from '../constants/environmentConfig';

import homeEs from '../../public/locales/home/es.json';
import homeEn from '../../public/locales/home/en.json';
import citizenPortalEs from '../../public/locales/citizenPortal/es.json';
import citizenPortalEn from '../../public/locales/citizenPortal/en.json';
import signInEs from '../../public/locales/signIn/es.json';
import signInEn from '../../public/locales/signIn/en.json';
import commonEs from '../../public/locales/common/es.json';
import commonEn from '../../public/locales/common/en.json';
import registerEs from '../../public/locales/register/es.json';
import registerEn from '../../public/locales/register/en.json';
import priceEs from '../../public/locales/price/es.json';
import priceEn from '../../public/locales/price/en.json';
import productEs from '../../public/locales/product/es.json';
import productEn from '../../public/locales/product/en.json';
import formEs from '../../public/locales/form/es.json';
import formEn from '../../public/locales/form/en.json';
import taskEs from '../../public/locales/task/es.json';
import taskEn from '../../public/locales/task/en.json';
import inspectionEs from '../../public/locales/inspection/es.json';
import inspectionEn from '../../public/locales/inspection/en.json';
import inspectorEs from '../../public/locales/inspector/es.json';
import inspectorEn from '../../public/locales/inspector/en.json';

import aboutUsEs from '../../public/locales/aboutUs/es.json';
import aboutUsEn from '../../public/locales/aboutUs/en.json';
import accessManagementEs from '../../public/locales/accessManagement/es.json';
import accessManagementEn from '../../public/locales/accessManagement/en.json';
import administrationEs from '../../public/locales/administration/es.json';
import administrationEn from '../../public/locales/administration/en.json';
import advancedAnalysisEs from '../../public/locales/advancedAnalysis/es.json';
import advancedAnalysisEn from '../../public/locales/advancedAnalysis/en.json';
import analysisAndReportsEs from '../../public/locales/analysisAndReports/es.json';
import analysisAndReportsEn from '../../public/locales/analysisAndReports/en.json';
import barcodeScannerEs from '../../public/locales/barcodeScanner/es.json';
import barcodeScannerEn from '../../public/locales/barcodeScanner/en.json';
import basketEs from '../../public/locales/basket/es.json';
import basketEn from '../../public/locales/basket/en.json';
import contactUsEs from '../../public/locales/contactUs/es.json';
import contactUsEn from '../../public/locales/contactUs/en.json';
import dataUploadEs from '../../public/locales/dataUpload/es.json';
import dataUploadEn from '../../public/locales/dataUpload/en.json';
import footerEs from '../../public/locales/footer/es.json';
import footerEn from '../../public/locales/footer/en.json';
import mainProductEs from '../../public/locales/mainProduct/es.json';
import mainProductEn from '../../public/locales/mainProduct/en.json';
import newsletterEs from '../../public/locales/newsletter/es.json';
import newsletterEn from '../../public/locales/newsletter/en.json';
import newsLetterViewEs from '../../public/locales/newsLetterView/es.json';
import newsLetterViewEn from '../../public/locales/newsLetterView/en.json';
import priceAlertsConfigurationEs from '../../public/locales/priceAlertsConfiguration/es.json';
import priceAlertsConfigurationEn from '../../public/locales/priceAlertsConfiguration/en.json';
import productAndBasketManagementEs from '../../public/locales/productAndBasketManagement/es.json';
import productAndBasketManagementEn from '../../public/locales/productAndBasketManagement/en.json';
import productCategoryEs from '../../public/locales/productCategory/es.json';
import productCategoryEn from '../../public/locales/productCategory/en.json';
import topNavigationEs from '../../public/locales/topNavigation/es.json';
import topNavigationEn from '../../public/locales/topNavigation/en.json';
import userManagementEs from '../../public/locales/userManagement/es.json';
import userManagementEn from '../../public/locales/userManagement/en.json';

const supportedLngs = Configuration.languages.map((language) => language.symbol);

const createLocaleLoadTimeoutSignal = (): AbortSignal => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ENVIRONMENT_CONFIG.LOCALE_LOAD_TIMEOUT);
  return controller.signal;
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    partialBundledLanguages: true,
    resources: {
      es: {
        home: homeEs,
        citizenPortal: citizenPortalEs,
        signIn: signInEs,
        common: commonEs,
        register: registerEs,
        price: priceEs,
        product: productEs,
        form: formEs,
        task: taskEs,
        inspection: inspectionEs,
        inspector: inspectorEs,
        aboutUs: aboutUsEs,
        accessManagement: accessManagementEs,
        administration: administrationEs,
        advancedAnalysis: advancedAnalysisEs,
        analysisAndReports: analysisAndReportsEs,
        barcodeScanner: barcodeScannerEs,
        basket: basketEs,
        contactUs: contactUsEs,
        dataUpload: dataUploadEs,
        footer: footerEs,
        mainProduct: mainProductEs,
        newsletter: newsletterEs,
        newsLetterView: newsLetterViewEs,
        priceAlertsConfiguration: priceAlertsConfigurationEs,
        productAndBasketManagement: productAndBasketManagementEs,
        productCategory: productCategoryEs,
        topNavigation: topNavigationEs,
        userManagement: userManagementEs,
      },
      en: {
        home: homeEn,
        citizenPortal: citizenPortalEn,
        signIn: signInEn,
        common: commonEn,
        register: registerEn,
        price: priceEn,
        product: productEn,
        form: formEn,
        task: taskEn,
        inspection: inspectionEn,
        inspector: inspectorEn,
        aboutUs: aboutUsEn,
        accessManagement: accessManagementEn,
        administration: administrationEn,
        advancedAnalysis: advancedAnalysisEn,
        analysisAndReports: analysisAndReportsEn,
        barcodeScanner: barcodeScannerEn,
        basket: basketEn,
        contactUs: contactUsEn,
        dataUpload: dataUploadEn,
        footer: footerEn,
        mainProduct: mainProductEn,
        newsletter: newsletterEn,
        newsLetterView: newsLetterViewEn,
        priceAlertsConfiguration: priceAlertsConfigurationEn,
        productAndBasketManagement: productAndBasketManagementEn,
        productCategory: productCategoryEn,
        topNavigation: topNavigationEn,
        userManagement: userManagementEn,
      },
    },
    backend: {
      loadPath: '/locales/{{ns}}/{{lng}}.json',
      requestOptions: () => ({
        signal: createLocaleLoadTimeoutSignal(),
      }),
    },
    supportedLngs: supportedLngs,
    fallbackLng: 'en',
    debug: ENVIRONMENT_CONFIG.I18_DEBUG_LOGS,
    ns: [
      'home',
      'citizenPortal',
      'signIn',
      'common',
      'register',
      'price',
      'product',
      'form',
      'task',
      'inspection',
      'inspector',
      'aboutUs',
      'accessManagement',
      'administration',
      'advancedAnalysis',
      'analysisAndReports',
      'auditLog',
      'barcodeScanner',
      'basket',
      'contactUs',
      'dataUpload',
      'footer',
      'mainProduct',
      'newsletter',
      'newsLetterView',
      'priceAlertsConfiguration',
      'productAndBasketManagement',
      'productCategory',
      'profile',
      'topNavigation',
      'userManagement',
    ],
  });

export default i18n;
